<template>
  <CarouselList :title="$t('xiang-si-tui-jian-1')" :total="digitalHumanList?.length || 0">
    <SwiperSlide v-for="template in digitalHumanList" :key="template.id">
      <ContentCharacterCard
        :key="template.id"
        :data="template"
        target="_blank"
        @change="onChange($event, template)"
        class="detail-character-recommend-card"
      />
    </SwiperSlide>
  </CarouselList>
</template>
<script lang="ts" setup>
import { SwiperSlide } from 'swiper/vue';
import type { Character } from '~/api/interface/character';
import CarouselList from '../carousel-list.vue';

interface CommonScenariosProps {
  digitalHumanList?: Character[];
}

const props = defineProps<CommonScenariosProps>();

provideResourceLocation({
  source: SOURCE.CHARACTER_DETAIL_COMMON_RACE,
});

const onChange = ([key, value]: [string, Character], data: Character) => {
  const item: any = props.digitalHumanList?.find(item => item.id === data.id);
  if (item) {
    item[key] = value;
  }
};
</script>
<style lang="scss" scoped>
.detail-character-recommend-card {
  &:deep(.name) {
    color: var(--x-text-1);
    text-align: center;
    font-size: 16px;
    margin-top: 4px;
    font-weight: var(--x-weight-medium, 500);
  }
}
</style>
